import { Injectable } from '@angular/core';

import { environment } from '../environment';
import { ISystemMessage, ISystemMessageCategory, IUserSystemMessageStatus } from '../types';

import { Api } from './api';

@Injectable({
    providedIn: 'root'
})
export class SystemMessagesApi {
    constructor(private readonly api: Api) { }

    async getSystemMessages() {
        return await this.api.http2.graphqlRequest<ISystemMessage[]>(`query GetSystemMessages($applicationId: Int) {
                systemMessage(applicationId: $applicationId) { id, title, message, startDate, expirationDate, createDate, systemMessageCategoryId }
            }`, { applicationId: environment.appId }, 'GET', 'systemMessage');
    }

    async deleteSystemMessage(systemMessageId: number) {
        return await this.api.http2.graphqlRequest<boolean>(`mutation DeleteSystemMessage($systemMessageId: Int!) {
            deleteSystemMessage(id: $systemMessageId)
        }`, { systemMessageId }, 'POST', 'deleteSystemMessage');
    }

    async saveSystemMessage(systemMessage: ISystemMessage, userId: number) {
        return await this.api.http2.graphqlRequest<ISystemMessage>(`mutation SaveSystemMessage($systemMessage: SystemMessageInput!, $applicationId: Int!, $userId: Int!) {
            saveSystemMessage(systemMessage: $systemMessage, applicationId: $applicationId, userId: $userId) { id, title, message, startDate, expirationDate, systemMessageCategoryId }
        }`, { systemMessage, userId, applicationId: environment.appId }, 'POST', 'saveSystemMessage');
    }

    async getUserSystemMessageStatus(userId: number) {
        return await this.api.http2.graphqlRequest<IUserSystemMessageStatus[]>(`query GetUserSystemMessageStatus($applicationId: Int, $userId: Int) {
                userSystemMessageStatus(applicationId: $applicationId, userId: $userId) { systemMessageId, userId, isRead, isDismissed, systemMessage { message, expirationDate, startDate, systemMessageCategoryId, title } }
            }`, { applicationId: environment.appId, userId }, 'GET', 'userSystemMessageStatus');
    }

    async saveUserSystemMessageStatus(systemMessageId: number, userId: number, isDismissed: boolean = false) {
        return await this.api.http2.graphqlRequest<IUserSystemMessageStatus>(`mutation SaveUserSystemMessageStatus($systemMessageId: Int!, $userId: Int!, $isDismissed: Boolean) {
            saveUserSystemMessageStatus(systemMessageId: $systemMessageId, userId: $userId, isDismissed: $isDismissed) { systemMessageId, userId, isRead, isDismissed }
        }`, { systemMessageId, userId, isDismissed }, 'POST', 'saveUserSystemMessageStatus');
    }

    async getSystemMessageCategories() {
        return await this.api.http2.graphqlRequest<ISystemMessageCategory[]>(`{
            systemMessageCategory { id, categoryName }
        }`, null, 'GET', 'systemMessageCategory');
    }
}
